// src/components/EquipmentManager/SpecsTab.jsx

import React from 'react';
import PropTypes from 'prop-types';
import { FaBox, FaStar, FaCheckCircle, FaHashtag, FaDollarSign, FaTag } from 'react-icons/fa';
import styles from './SpecsTab.module.css';

const SpecsTab = ({ equipment }) => {
  const specs = [
    { 
      icon: <FaBox />, 
      label: 'Category', 
      // Handle both old (string) and new (object) formats
      value: equipment.category?.name || equipment.category || equipment.categoryName || 'N/A',
      displayIcon: equipment.category?.icon || '',
      show: !!(equipment.category || equipment.categoryName)
    },
    { 
      icon: <FaStar />, 
      label: 'Skill Level', 
      value: equipment.skillLevel || 'All Levels',
      show: true
    },
    { 
      icon: <FaCheckCircle />, 
      label: 'Condition', 
      value: equipment.condition || 'Good',
      show: true
    },
    { 
      icon: <FaHashtag />, 
      label: 'Quantity', 
      value: equipment.quantity || 'N/A',
      show: equipment.quantity !== undefined
    },
    { 
      icon: <FaDollarSign />, 
      label: 'Average Price', 
      value: equipment.averagePrice ? `$${equipment.averagePrice}` : 'N/A',
      show: equipment.averagePrice !== undefined
    },
    { 
      icon: <FaTag />, 
      label: 'Sport', 
      value: equipment.sportName,
      show: !!equipment.sportName
    },
    { 
      icon: <FaCheckCircle />, 
      label: 'Required Equipment', 
      value: equipment.isRequired ? 'Yes' : 'No',
      show: equipment.isRequired !== undefined
    }
  ];
  
  return (
    <div className={styles.specsTab}>
      <div className={styles.specsGrid}>
        {specs.filter(spec => spec.show).map((spec, index) => (
          <div key={index} className={styles.specItem}>
            <div className={styles.specIcon}>{spec.icon}</div>
            <div className={styles.specContent}>
              <div className={styles.specLabel}>{spec.label}</div>
              <div className={styles.specValue}>
                {spec.displayIcon && <span style={{marginRight: '8px'}}>{spec.displayIcon}</span>}
                {spec.value}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Tags */}
      {equipment.tags && equipment.tags.length > 0 && (
        <div className={styles.tagsSection}>
          <h3 className={styles.sectionTitle}>Tags</h3>
          <div className={styles.tagsList}>
            {equipment.tags.map((tag, index) => (
              <span key={index} className={styles.tag}>
                {tag}
              </span>
            ))}
          </div>
        </div>
      )}
      
      {/* Notes Section */}
      {equipment.notes && (
        <div className={styles.notesSection}>
          <h3 className={styles.sectionTitle}>Notes</h3>
          <p className={styles.notesText}>{equipment.notes}</p>
        </div>
      )}
    </div>
  );
};

SpecsTab.propTypes = {
  equipment: PropTypes.object.isRequired
};

export default SpecsTab;

